<template>
  <div class="backgroundMedios" id="background7">
    <div class="transbox" id="transbox7">
      <h1 class="pulse">Medios</h1>
      <br>
      <ul>
        <li>Cabezas Tractoras</li>
        <li>Camión de alta succión y gran tonelaje</li>
        <li>Camión Pulpo</li>
        <li>Camión Gancho</li>
        <li>Camión-cisterna aceite</li>
        <li>Semirremolques cisterna</li>
        <li>Semirremolques caja</li>
        <li>Semirremolques bañera</li>
        <li>Contenedores de 13 y 20 TM</li>
      </ul>

      <h2>Medios</h2>
      <div class="container" id="gallery1">
        <ul>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio1.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión succión</h3>
                <p>Camión succión gran tonelaje</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio2.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión succión</h3>
                <p>Limpieza de fosa séptica </p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio3.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión succión</h3>
                <p>Limpieza decantadores hidrocarburos</p>
              </div>
            </li >
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio4.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión caja</h3>
                <p>Recogida de residuos varios</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio5.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión caja</h3>
                <p>Residuos de talleres, industrias, etc</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio6.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Furgoneta</h3>
                <p>Recogida de pequeñas cantidades de residuos en lugares de difícil acceso</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio7.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Semiremolque caja</h3>
                <p>Recogida de residuos a granel </p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio8.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Semiremolque cisterna</h3>
                <p>Recogida de residuos líquidos</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio10.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión gancho / pulpo</h3>
                <p>Recogida de residuos grúa</p>
              </div>
            </li>
            <li class="photo">
              <a class="normal" >
                <img src="../assets/gallery/MEDIOS/medio9.jpg" width="200" height="200">
                  <g>
                    <path d="M 68.9708 24.8623 L 60.4554 2.3018 C 59.9641 0.7017 58.1628 -0.2583 56.5252 0.3817 L 1.9822 20.2222 C 0.3822 20.7022 -0.4179 22.6222 0.2222 24.2223 L 8.8624 47.7797 L 8.8624 35.1484 C 8.8624 29.5024 13.3425 24.8623 18.8857 24.8623 L 32.9442 24.8623 L 50.63 12.862 L 60.7829 24.8623 L 68.9708 24.8623 L 68.9708 24.8623 ZM 77.098 32.0625 L 18.8857 32.0625 C 17.2512 32.0625 16.0625 33.4511 16.0625 35.1484 L 16.0625 72.8491 C 16.0625 74.5477 17.2512 75.9375 18.8857 75.9375 L 77.098 75.9375 C 78.742 75.9375 79.9376 74.5477 79.9376 72.8491 L 79.9376 35.1484 C 79.9376 33.4511 78.742 32.0625 77.098 32.0625 L 77.098 32.0625 ZM 73.0626 68.0625 L 23.9375 68.0625 L 23.9375 61.0852 L 31.4704 43.7232 L 42.7696 57.6777 L 53.4138 46.8062 L 67.1695 41.9375 L 73.0626 55.0815 L 73.0626 68.0625 L 73.0626 68.0625 Z"></path>
                  </g>
              </a>
              <div class="info">
                <h3>Camión cisterna aceite</h3>
                <p>Recogida de aceite industrial</p>
              </div>
            </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Medios',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background7").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox7").classList.add("animation")
      } 
    })

    setTimeout(() => {  
      //Galeria
      const nodes1 = document.querySelector("#gallery1").getElementsByClassName("photo");
      const directions = {
        0:'top',
        1:'right',
        2:'bottom',
        3:'left'
      };
      const classNames = ['in', 'out'].map(p=>Object.values(directions).map(d => p + "-" + d)).reduce((a,b) => a.concat(b));
      const getDirectionKey = (ev, node) => {
        const {
          width,
          height,
          top,
          left
        } = node.getBoundingClientRect();
        const l = ev.pageX - (left + window.pageXOffset);
        const t = ev.pageY - (top + window.pageYOffset);
        const x = (l - (width/2) * (width > height ? height / width : 1));
        const y = (t - (height/2) * (height > width ? width / height : 1));
        return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
      };
      class Item {
        constructor(element) {
          this.element = element;    
          this.element.addEventListener('mouseover', (ev) => this.update(ev, 'in'));
          this.element.addEventListener('mouseout', (ev) => this.update(ev, 'out'));
        }
        
        update(ev, prefix) {
          this.element.classList.remove(...classNames);
          this.element.classList.add(prefix+ "-" + directions[getDirectionKey(ev, this.element)]);
        }
      }
      for (let i = 0; i < nodes1.length; i++) {
        new Item(nodes1[i]);
        
      }
     }, 100);
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
h2 {
  text-align: center;
}

div.backgroundMedios {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
  margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}

div {
  font-size: 30px;
}

.animation{
  animation-name: opacity1;
  animation-duration: 1500ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}


/* Galeria */
/* the important bits */
  li {
    perspective: 400px;
  }
  .info {
    transform: rotate3d(1, 0, 0, 90deg);
    width: 100%;
    height: 100%;
    padding: 20px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
    pointer-events: none;
    background-color: rgba(26, 188, 156, 0.9);
  }
  .in-top .info {
    transform-origin: 50% 0%;
    animation: in-top 300ms ease 0ms 1 forwards;
  }
  .in-right .info {
    transform-origin: 100% 0%;
    animation: in-right 300ms ease 0ms 1 forwards;
  }
  .in-bottom .info {
    transform-origin: 50% 100%;
    animation: in-bottom 300ms ease 0ms 1 forwards;
  }
  .in-left .info {
    transform-origin: 0% 0%;
    animation: in-left 300ms ease 0ms 1 forwards;
  }
  .out-top .info {
    transform-origin: 50% 0%;
    animation: out-top 300ms ease 0ms 1 forwards;
  }
  .out-right .info {
    transform-origin: 100% 50%;
    animation: out-right 300ms ease 0ms 1 forwards;
  }
  .out-bottom .info {
    transform-origin: 50% 100%;
    animation: out-bottom 300ms ease 0ms 1 forwards;
  }
  .out-left .info {
    transform-origin: 0% 0%;
    animation: out-left 300ms ease 0ms 1 forwards;
  }
  @keyframes in-top {
    from {
      transform: rotate3d(-1, 0, 0, 90deg);
    }
    to {
      transform: rotate3d(0, 0, 0, 0deg);
    }
  }
  @keyframes in-right {
    from {
      transform: rotate3d(0, -1, 0, 90deg);
    }
    to {
      transform: rotate3d(0, 0, 0, 0deg);
    }
  }
  @keyframes in-bottom {
    from {
      transform: rotate3d(1, 0, 0, 90deg);
    }
    to {
      transform: rotate3d(0, 0, 0, 0deg);
    }
  }
  @keyframes in-left {
    from {
      transform: rotate3d(0, 1, 0, 90deg);
    }
    to {
      transform: rotate3d(0, 0, 0, 0deg);
    }
  }
  @keyframes out-top {
    from {
      transform: rotate3d(0, 0, 0, 0deg);
    }
    to {
      transform: rotate3d(-1, 0, 0, 104deg);
    }
  }
  @keyframes out-right {
    from {
      transform: rotate3d(0, 0, 0, 0deg);
    }
    to {
      transform: rotate3d(0, -1, 0, 104deg);
    }
  }
  @keyframes out-bottom {
    from {
      transform: rotate3d(0, 0, 0, 0deg);
    }
    to {
      transform: rotate3d(1, 0, 0, 104deg);
    }
  }
  @keyframes out-left {
    from {
      transform: rotate3d(0, 0, 0, 0deg);
    }
    to {
      transform: rotate3d(0, 1, 0, 104deg);
    }
  }
  /* you can ignore this ones */

  ul:after {
    content: "";
    display: table;
    clear: both;
  }
  .photo {
    position: relative;
    float: left;
    width: 200px;
    height: 200px;
    margin: 5px;
    padding: 0;
    list-style: none;
  }
  li a {
    display: inline-block;
    vertical-align: top;
    text-decoration: none;
    border-radius: 4px;
  }
  li h3 {
    margin: 0;
    font-size: 20px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    
  }
  li p {
    font-size: 16px;
    line-height: 1;
    font-style: italic;
    padding-top: 10px;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
  }
  li .normal {
    width: 100%;
    height: 100%;
    background-color: white;
    color: rgba(52, 73, 94, 0.6);
    box-shadow: inset 0 2px 20px white;
    text-align: center;
    font-size: 50px;
    line-height: 200px;
  }
  li .normal svg {
    pointer-events: none;
    width: 50px;
  }
  li .normal svg path {
    fill: rgba(52, 73, 94, 0.2);
  }
  * {
    box-sizing: border-box;
  }
  body {
    background-color: white;
  }
  h3 {
    font-family: 'Bree Serif', serif;
  }
  .container {
    width: inherit;
    margin: auto;
    min-width: 200px;
  }
  header {
    font-family: 'Bree Serif', serif;
    text-align: center;
    margin: 50px 0 25px;
    color: #34495e;
  }
  header p {
    margin: 0;
    color: rgba(52, 73, 94, 0.4);
  }
  img{
    max-width: 200px;
    max-height: 200px;
    /*
    height: auto;
    width: auto;
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    */
  }
  .pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>